import { createContext, type ReactNode } from 'react';

/** @internal */
export interface MobileMenuNavigationLevel {
  title: ReactNode;
  content: ReactNode;
}

/** @internal */
export interface MobileMenuNavigationContextValue {
  stack: MobileMenuNavigationLevel[];
  direction: 'forward' | 'back';
  rootTitle: ReactNode;
  push(level: MobileMenuNavigationLevel): void;
  pop(): void;
}

/** @internal */
export const MobileMenuNavigationContext =
  createContext<MobileMenuNavigationContextValue>({
    stack: [],
    direction: 'forward',
    rootTitle: null,
    push: () => null,
    pop: () => null,
  });
